"use strict";
(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[3166],{

/***/ 46573:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   LS: () => (/* binding */ offerForAnalytics),
/* harmony export */   Y_: () => (/* binding */ offers),
/* harmony export */   _m: () => (/* binding */ coupons)
/* harmony export */ });




const offers = {
    noDiscount: "noDiscount",
    freeCase: "freeCase",
    freeProduct: "freeProduct",
    discount: "discount",
    off50: "off50",
    off60: "off60"
};
const coupons = {
    freeCase: "UPDCARDFREECASE",
    freeProduct: "UPDCARDFREEPRODUCT",
    discount: "UPDCARD695",
    off50: "UPDCARD50",
    off60: "UPDCARD60"
};
const offerForAnalytics = {
    "noDiscount": "No offer",
    "freeCase": "Free case",
    "freeProduct": "Free product",
    "discount": "$6.95 off",
    "off50": "50% off",
    "off60": "60% off"
};


/***/ }),

/***/ 11438:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ cardUpdate_useCardUpdateData)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./src/modules/cardUpdate/usePaymentMethod.ts
var usePaymentMethod = __webpack_require__(22839);
// EXTERNAL MODULE: ./local_modules/router/util/contexts.ts
var contexts = __webpack_require__(84584);
// EXTERNAL MODULE: ./src/modules/subscription/subscription/index.tsx + 1 modules
var subscription_subscription = __webpack_require__(91339);
// EXTERNAL MODULE: ./src/modules/cardUpdate/index.ts
var cardUpdate = __webpack_require__(46573);
// EXTERNAL MODULE: ./src/modules/user/shownPopups/index.tsx + 2 modules
var user_shownPopups = __webpack_require__(86506);
;// CONCATENATED MODULE: ./src/modules/cardUpdate/useCardUpdateOffer.ts





// Priority is important and used in business logic
const offers = [
    "noDiscount",
    "freeCase",
    "freeProduct",
    "discount",
    // 'litePlan',
    "off50"
];
// ATTN because we use this hook in many places every instance can call fetchNextOffer on mount,
//  so we need to run only one update in parallel
let isNextOfferFetching = false;
const maxLifeTime = 24 * 60 * 60 * 1000 // 24h
;
const getTimeLeft = function(lastUpdated) {
    let expired = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (expired) {
        return 0;
    }
    const timePassed = lastUpdated ? Date.now() - new Date(lastUpdated).getTime() : 0;
    return Math.max(maxLifeTime - timePassed, 0);
};
const useCardUpdateOffer = ()=>{
    const { subscription, isFetching: isSubscriptionFetching } = (0,subscription_subscription/* useSubscription */.mU)();
    const { shownPopups, isFetching: isShownPopupsFetching } = (0,user_shownPopups/* useShownPopups */.BP)();
    const { paymentMethod, isPaymentMethodFetching } = (0,usePaymentMethod/* default */.Z)();
    const setPopupShown = (0,user_shownPopups/* useSetPopupShown */.aw)();
    const [searchParams] = (0,contexts/* useSearchParams */.lr)();
    // to rewrite offer
    const [forceOffer, setForceOffer] = (0,react.useState)(searchParams.forceOffer);
    const queryOfferExpiredRef = (0,react.useRef)(Boolean(searchParams.expired));
    const subscriptionDate = subscription?.subscriptionDate;
    const isOfferFetching = isShownPopupsFetching || isSubscriptionFetching || isPaymentMethodFetching;
    const bannerName = (0,react.useMemo)(()=>{
        if (isOfferFetching) {
            return null;
        }
        const postfix = paymentMethod?.id || (subscriptionDate ? new Date(subscriptionDate).getTime() : null);
        return postfix ? `CardUpdateOffer_${postfix}` : null;
    }, [
        subscriptionDate,
        paymentMethod,
        isOfferFetching
    ]);
    const { offer, coupon, timeLeft } = (0,react.useMemo)(()=>{
        if (isOfferFetching) {
            return {};
        }
        const { count = 1, lastUpdated } = shownPopups[bannerName] || {};
        const timeLeft = getTimeLeft(lastUpdated, queryOfferExpiredRef.current);
        // last offer is last available, if timeLeft is zero, we can go to the next offer
        const offerIndex = Math.min(offers.length - 1, timeLeft === 0 ? count : count - 1);
        let offer = offers[offerIndex];
        if (offers.includes(forceOffer)) {
            offer = forceOffer;
        }
        const coupon = cardUpdate/* coupons */._m[offer];
        return {
            offer,
            coupon,
            timeLeft
        };
    }, [
        shownPopups,
        bannerName,
        isOfferFetching,
        forceOffer
    ]);
    const fetchNextOffer = (0,react.useCallback)((currentOffer)=>{
        if (currentOffer === offers[offers.length - 1]) {
            setForceOffer(cardUpdate/* offers */.Y_.noDiscount);
            return;
        }
        if (isNextOfferFetching) {
            return;
        }
        isNextOfferFetching = true;
        setPopupShown(bannerName).finally(()=>{
            isNextOfferFetching = false;
        });
    }, [
        bannerName,
        setPopupShown
    ]);
    (0,react.useEffect)(()=>{
        if (isOfferFetching) {
            return;
        }
        if (shownPopups && bannerName) {
            // sets count to 1 if there is no banner at all
            if (!shownPopups[bannerName]) {
                fetchNextOffer();
                return;
            }
            // ATTN we don't change offer when time is out, only when user refresh the page
            const { count, lastUpdated } = shownPopups[bannerName];
            const timeLeft = getTimeLeft(lastUpdated, queryOfferExpiredRef.current);
            if (timeLeft === 0 && count <= offers.length) {
                fetchNextOffer();
                queryOfferExpiredRef.current = null;
            }
        }
    }, [
        bannerName,
        fetchNextOffer,
        isOfferFetching,
        shownPopups
    ]);
    return {
        offer,
        offerForAnalytics: cardUpdate/* offerForAnalytics */.LS[offer],
        coupon,
        timeLeft,
        isOfferFetching,
        fetchNextOffer
    };
};
/* harmony default export */ const cardUpdate_useCardUpdateOffer = (useCardUpdateOffer);

// EXTERNAL MODULE: ./local_modules/logger/index.ts
var logger = __webpack_require__(58738);
// EXTERNAL MODULE: ./src/helpers/modifiers/formatPrice.ts
var formatPrice = __webpack_require__(72160);
;// CONCATENATED MODULE: ./src/modules/cardUpdate/messages.ts
/* harmony default export */ const messages = ({
    noDiscount: {
        title: {
            default: {
                en: "Oops, looks like there was a problem with\xa0your payment method..."
            },
            creditCard: {
                en: "There was an issue with your card"
            }
        },
        text: {
            default: {
                en: "Please update your payment info now to reactivate your account!"
            },
            creditCard: {
                en: `
          But don't worry, we can fix it. Your card ••{lastDigits}
          appears to be inactive, so please update your
          payment info so we can reactivate your account.
        `
            }
        }
    },
    modalOrQueueBannerNoDiscount: {
        title: {
            en: "Oops, looks like there was a problem with your {isCard, select, true {card} false {payment method}}..."
        },
        text: {
            default: {
                en: "Please update your payment info now to reactivate your account!"
            },
            creditCard: {
                en: `
           Your card • {lastDigits} is inactive. Please update your payment info now to reactivate your account!
        `
            }
        }
    },
    freeCase: {
        title: {
            en: "You've unlocked a free case!"
        },
        text: {
            en: "Update your payment info, and we'll throw a free atomizer into your next order."
        }
    },
    freeProduct: {
        title: {
            en: "You've unlocked a free scent"
        },
        text: {
            en: `
        Yes, really. Update your payment info, and we'll throw
        a free bottle of {name} into your next order.
      `
        }
    },
    discount: {
        title: {
            en: "Your next payment is {charge}"
        },
        text: {
            en: "Save {discount} when you update your payment info now."
        }
    },
    off50: {
        title: {
            en: "We'll meet you halfway"
        },
        text: {
            en: "Update your payment info, and your next month is 50% off."
        }
    }
});

;// CONCATENATED MODULE: ./src/modules/cardUpdate/useCardUpdateTexts.ts




const useCardUpdateTexts = (props)=>{
    const { offer, couponData, type, lastDigits, placement } = props;
    if (offer === cardUpdate/* offers */.Y_.noDiscount || !couponData) {
        const isCard = Boolean(type === "CREDIT_CARD" && lastDigits);
        if (placement === "modalOrQueuePageBanner") {
            const offerMessages = messages.modalOrQueueBannerNoDiscount;
            return {
                title: {
                    ...offerMessages.title,
                    values: {
                        isCard
                    }
                },
                text: isCard ? {
                    ...offerMessages.text.creditCard,
                    values: {
                        lastDigits
                    }
                } : offerMessages.text.default
            };
        }
        const { title, text } = messages.noDiscount;
        return {
            title: isCard ? title.creditCard : title.default,
            text: lastDigits ? {
                ...text.creditCard,
                values: {
                    lastDigits
                }
            } : text.default
        };
    }
    const offerMessages = messages[offer];
    if (!offerMessages) {
        logger/* default */.Z.warn(new Error(`No messages found for the offer ${offer}`));
        return {};
    }
    const { title, text } = offerMessages;
    const { freeProduct, discountAmount, totalAmount } = couponData || {};
    if (offer === cardUpdate/* offers */.Y_.discount) {
        const charge = (0,formatPrice/* default */.Z)(totalAmount);
        const discount = (0,formatPrice/* default */.Z)(discountAmount);
        return {
            title: {
                ...title,
                values: {
                    charge
                }
            },
            text: {
                ...text,
                values: {
                    discount
                }
            }
        };
    }
    if (offer === cardUpdate/* offers */.Y_.freeProduct) {
        const { name } = freeProduct || {};
        return {
            title,
            text: {
                ...text,
                values: {
                    name
                }
            }
        };
    }
    return {
        title,
        text
    };
};
/* harmony default export */ const cardUpdate_useCardUpdateTexts = (useCardUpdateTexts);

// EXTERNAL MODULE: ./src/modules/coupon/useCouponData.ts
var useCouponData = __webpack_require__(5881);
;// CONCATENATED MODULE: ./src/modules/cardUpdate/useCardUpdateData.ts




// common hook to fetch all data required for card update flow (banners/pages)
const useCardUpdateData = function() {
    let { placement } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { paymentMethod, isPaymentMethodFetching } = (0,usePaymentMethod/* default */.Z)();
    const { subscription } = (0,subscription_subscription/* useSubscription */.mU)();
    const { offer, offerForAnalytics, coupon, timeLeft, isOfferFetching, fetchNextOffer } = cardUpdate_useCardUpdateOffer();
    const { couponData, isCouponDataFetching, isCouponUnavailable } = (0,useCouponData/* default */.Z)({
        couponCode: coupon
    });
    // TODO remove after fix on backend, totalAmount should account discount, but it doesn't
    //  - added on 12.08.2022 by sonatskiy
    const planPrice = subscription?.plan?.price;
    if (planPrice === couponData?.totalAmount && couponData?.discountAmount) {
        couponData.totalAmount = planPrice - couponData.discountAmount;
    }
    (0,react.useEffect)(()=>{
        if (isCouponUnavailable) {
            fetchNextOffer(offer);
        }
    }, [
        offer,
        isCouponUnavailable,
        fetchNextOffer
    ]);
    const { title, text } = cardUpdate_useCardUpdateTexts({
        offer,
        couponData,
        type: paymentMethod?.type,
        lastDigits: paymentMethod?.lastDigits,
        placement
    });
    const freeProduct = couponData?.freeProduct;
    const isCardUpdateDataFetching = isPaymentMethodFetching || isOfferFetching || isCouponDataFetching || isCouponUnavailable;
    return {
        offer,
        offerForAnalytics,
        coupon,
        timeLeft,
        couponData,
        freeProduct,
        paymentMethod,
        offerInfo: {
            title,
            text
        },
        isCardUpdateDataFetching
    };
};
/* harmony default export */ const cardUpdate_useCardUpdateData = (useCardUpdateData);


/***/ }),

/***/ 22839:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var modules_user__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27959);

const usePaymentMethod = ()=>{
    const { primaryPaymentMethod, isFetching } = (0,modules_user__WEBPACK_IMPORTED_MODULE_0__/* .usePaymentMethods */ .Ew)();
    return {
        paymentMethod: primaryPaymentMethod,
        isPaymentMethodFetching: isFetching
    };
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (usePaymentMethod);


/***/ })

}]);